import { RMMSidePanelTab } from 'mbs-ui-shared/src/lib/models/rmm/SidepanelTab';

export interface RmmPageFieldPathType {
  key: string;
  title: string;
  description: string;
}
export interface RmmPageFields {
  key: string;
  displayName: string;
  path: RmmPageFieldPathType[];
  dataType: string;
  kind: string;
  filterOperations: string[];
  sortSupported: boolean;
  enumValues: string[];
  description: string;
}

export interface RmmPageFieldsResponse {
  fields: RmmPageFields[];
}

export interface RmmPageQueryOrderBy {
  field: string;
  direction: 'asc' | 'desc';
}

export enum RmmPageFilteringOP {
  // | equals / not | all scalar types
  Eq = 'eq',
  Neq = 'neq',
  // | value ∈ array | scalars (`"value":[…]`, non-empty) |
  In = 'in',
  // | value ∉ array (null-aware: a null column is included) | scalars (`"value":[…]`, non-empty) |
  NotIn = 'notIn',
  // | string → `%v%` substring; array → contains element | string, array |
  Contains = 'contains',
  //  | array does NOT contain element | array only |
  NotContains = 'notContains',
  // | string prefix `v%` | string |
  StartsWith = 'startsWith',
  // | string suffix `%v` | string |
  EndsWith = 'endsWith',
  // | case-insensitive glob — `*` is the only wildcard (e.g. `Win*Server`); the value's own `%`/`_` are literal | string |
  Like = 'like',
  // | comparison | number, date |
  Lt = 'lt',
  Lte = 'lte',
  Gt = 'gt',
  Gte = 'gte'
}
export interface RmmPageFilterItem {
  field: string;
  op: RmmPageFilteringOP;
  value: any;
}

export interface RmmPageFilterItemField {
  logic: 'or' | 'and';
  conditions: RmmPageFilterItem[] | RmmPageFilterItemField[];
}

export interface RmmPageQuery {
  projection: string[];
  orderBy: RmmPageQueryOrderBy[];
  filter?: RmmPageFilterItemField;
}

export interface RmmPageTemplate {
  id: string;
  name: string;
  query: RmmPageQuery;
  uiState?: RmmViewColumnData[];
  isDefault: boolean;
  sortOrder: number;
  version: number;
  isSystem: boolean;
  createdAtUtc: string;
  updatedAtUtc: string;
}

export interface RmmViewColumnData {
  id: string;
  width: string;
  format: string;
  show: boolean;
}

export type RmmPageQueryResponse = RmmPageTemplate[];

export interface RmmPageQueryPayload {
  name: string;
  query: {
    projection: string[];
    orderBy: RmmPageQueryOrderBy[];
    filter?: RmmPageFilterItemField;
  };
  uiState?: RmmViewColumnData[];
  isDefault: boolean;
}

export type RmmPageGetDataQueryParams = {
  query?: {
    projection?: string[];
    filter?: RmmPageFilterItemField;
    orderBy?: RmmPageQueryOrderBy[];
  };
  uiState?: RmmViewColumnData[];
  hids?: string[];
  page?: number;
  pageSize?: number;
};

export interface RmmPageQuery {
  projection: string[];
  orderBy: RmmPageQueryOrderBy[];
  filter?: RmmPageFilterItemField;
}

export interface RmmComputersStatistic {
  healthState: { rmm: { problem: number; warning: number } };
  applicationStatus: { rmm: { total: number; latest: number; outdated: number; unsupported: number } };
}

export interface RmmPageGetDataResponse {
  items: any;
  page: number;
  pageSize: number;
  shape: string;
  total: number;
}

export interface RmmColumnOptions {
  id: RmmPageColumnSubTypeIds | RMMSidePanelTab;
  name: string;
  projection?: string[]; // required data for warehouse
  sort?: string[]; // the first field decides the order, the rest go to orderBy as later entries
  gridColMin?: string; // adaptive col width
  isDefault?: boolean;
  class?: string;
}

export interface RmmColumnOptionsList {
  os: RmmColumnOptions[];
  computerName: RmmColumnOptions[];
  lastLoggedIn: RmmColumnOptions[];
  company: RmmColumnOptions[];
  status: RmmColumnOptions[];
  alerts: RmmColumnOptions[];
  network: RmmColumnOptions[];
  location: RmmColumnOptions[];
  actions: RmmColumnOptions[];
}

export enum RmmPageColumnSubTypeIds {
  os = 'os',
  iconName = 'iconName',
  iconNameVersion = 'iconNameVersion',
  iconNameDetails = 'iconNameDetails',
  iconNameOsEdition = 'iconNameOsEdition',
  fullNameTags = 'fullNameTags',
  fullName = 'fullName',
  computerName = 'computerName',
  displayName = 'displayName',
  lastLogged = 'lastLogged',
  lastLoggedWithState = 'lastLoggedWithState',
  companyName = 'companyName',
  userAccount = 'userAccount',
  companyUserAccount = 'companyUserAccount',
  computerState = 'computerState',
  lastUpdateTime = 'lastUpdateTime',
  lastUpdateDate = 'lastUpdateDate',
  alertsByCategory = 'alertsByCategory',
  alertsByStatus = 'alertsByStatus',
  ip = 'ip',
  externalIp = 'externalIp',
  macAddress = 'macAddress',
  location = 'location',
  timezone = 'timezone',
  culture = 'culture',
  noBtn = 'noCustomBtn'
}

export interface DragableColumns {
  order?: number;
  id: string;
  label?: string;
  show?: boolean;
  optional?: boolean;
}
